import { type AxiosResponse } from 'axios'
import { type AxiosOptions } from 'shared/api'
import { baseApi } from 'entities/Auth'
import {
  type IParamsConversion,
  type IParamsGetConversions,
  type IResponseConversion,
  type IResponseConversions,
} from 'entities/Conversion/api/types'

class Api {
  getConversions(
    params: IParamsGetConversions,
    options?: AxiosOptions
  ): Promise<AxiosResponse<IResponseConversions>> {
    return baseApi.get('conversions', {
      params,
      ...options,
    })
  }

  getConversionById(id: number): Promise<AxiosResponse<IResponseConversion>> {
    return baseApi.get(`conversions/${id}`)
  }

  createConversion(params: IParamsConversion): Promise<AxiosResponse<IResponseConversion>> {
    return baseApi.post('conversions', params)
  }

  clearConversion(id: number): Promise<AxiosResponse<void>> {
    return baseApi.post(`conversions/${id}/clear`)
  }

  updateConversion(
    id: number,
    params: IParamsConversion
  ): Promise<AxiosResponse<IResponseConversion>> {
    return baseApi.put(`conversions/${id}`, params)
  }

  deleteConversion(id: number): Promise<AxiosResponse<void>> {
    return baseApi.delete(`conversions/${id}`)
  }
}

export const ConversionsApi = new Api()
